import { featureCollection } from '@turf/helpers';
import axios from 'axios';
import { getAllImsmaHaRecordsGeojson, getImsmaHaSyncTimestamp } from 'api/HaApi';

let imsmaLastSyncInflight = null;
let imsmaLastSyncResolved;

export const fetchHAReportsImsmaLastSyncOnce = () => {
  if (imsmaLastSyncResolved !== undefined) {
    return Promise.resolve(imsmaLastSyncResolved);
  }
  if (imsmaLastSyncInflight) {
    return imsmaLastSyncInflight;
  }
  imsmaLastSyncInflight = getImsmaHaSyncTimestamp()
    .then((res) => {
      const raw =
        res?.data?.timestamp ??
        res?.data?.last_updated_at ??
        res?.data?.last_synced ??
        res?.data?.last_synced_at ??
        res?.data?.last_sync_at ??
        res?.data?.imsma_last_sync_at ??
        res?.data?.last_successful_imsma_ha_records_sync_at ??
        null;
      imsmaLastSyncResolved = raw || null;
      return imsmaLastSyncResolved;
    })
    .catch(() => {
      imsmaLastSyncResolved = null;
      return null;
    })
    .finally(() => {
      imsmaLastSyncInflight = null;
    });
  return imsmaLastSyncInflight;
};

export const fetchHAReportsPolygons = (setLoader, setPolygons, signal) => {
  setLoader(true);

  axios
    .get('/reports/global-map/?color_by=hazard_area_type', { signal })
    .then((res) => {
      const polygonData = res?.data?.polygon || featureCollection([]);
      setPolygons(polygonData);
      setLoader(false);
    })
    .catch((err) => {
      if (!axios.isCancel(err)) {
        console.error('Error fetching HA Reports polygons:', err);
      }
      setLoader(false);
    });
};

const COLOR_BY_HAZARD_AREA_TYPE = {
  'I3T|SHA': '#ff0000',
  '3T|CHA': '#ffa500',
};

const getDefaultColor = (feature) => {
  const type =
    feature?.properties?.hazard_area_type ||
    feature?.properties?.sha_cha ||
    feature?.properties?.sha_or_cha;
  return COLOR_BY_HAZARD_AREA_TYPE[type] || '#808080';
};

const ensureFeatureCollection = (payload) => {
  if (payload?.type === 'FeatureCollection' && Array.isArray(payload?.features)) {
    return payload;
  }
  if (payload?.results?.type === 'FeatureCollection' && Array.isArray(payload?.results?.features)) {
    return payload.results;
  }
  if (payload?.polygon?.type === 'FeatureCollection' && Array.isArray(payload?.polygon?.features)) {
    return payload.polygon;
  }
  return featureCollection([]);
};

const withPolygonColors = (collection) => ({
  ...collection,
  features: (collection?.features || []).map((feature) => ({
    ...feature,
    properties: {
      ...(feature?.properties || {}),
      color: feature?.properties?.color || getDefaultColor(feature),
    },
  })),
});

export const fetchImsmaHAReportsPolygons = (setPolygons, signal) => {
  getAllImsmaHaRecordsGeojson({ signal, pageSize: 2000 })
    .then((res) => {
      const payload = res?.data || res;
      const collection = ensureFeatureCollection(payload);
      setPolygons(withPolygonColors(collection));
    })
    .catch((err) => {
      if (!axios.isCancel(err)) {
        console.error('Error fetching IMSMA HA Reports polygons:', err);
      }
      setPolygons(featureCollection([]));
    });
};
